import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px',
    color: 'rgba(0, 0, 0, 0.87)',
    background: '#fff',
    overflow: 'initial',
  },
  checkBoxText: {
    alignContent: 'center',
  },
  checkBox: {
    padding: 0,
  },
  inputStyle: {
    font: 'inherit',
    width: '100%',
    border: 0,
    height: '1.1875em',
    margin: '0',
    padding: '6px 0 7px',
    display: 'block',
    minWidth: 0,
    boxSizing: 'content-box',
    background: 'none',
  },
}));
